module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindtt"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Published and Forthcoming by New Academia Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("GOD, GREED, AND GENOCIDE: The Holocaust through the Centuries, by Arthur Grenke.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("NATIONALISM, HISTORIOGRAPHY AND THE (RE)CONSTRUCTION OF THE PAST, edited by Claire Norton")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("AN ARCHITECT OF DEMOCRACY: Buildig a Mosaic of Peace, by James Robert Huntley.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("SHAKESPEARE’S THEATER OF LIKENESS, by R. Allen Shoaf.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("HERETICAL EMPIRICISM, by Pier Paolo Pasolini. Eds., trs., Ben Lawton and Louise K.Barnett.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("ON THE ROAD TO BAGHDAD, OR TRAVELING BICULTURALISM: Theorizing a Bicultural Approach to Contemporary World Fiction, Edited by Gönül Pultar.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("LIVING NOVELS: A JOURNEY THROUGH TWENTIETH-CENTURY FICTION, by Sascha Talmor")]), _vm._v(" "), _c('p', {
    staticClass: "noindt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Russian History and Culture Series")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("RUSSIAN FUTURISM: A HISTORY, by Vladimir Markov. With an Introduction by Ronald Vroon.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("WORDS IN REVOLUTION: Russian Futurist Manifestoes 1912-1928. Eds., trs., Anna Lawton and Herbert Eagle.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("THE INNER ADVERSARY: Struggle Against Philistinism as the Moral Mission of the Russian Intelligentsia, by Timo Vihavainen.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("IMAGING RUSSIA 2000: FILM AND FACTS, Anna Lawton (CHOICE Outstanding Academic Title 2005)")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("BEFORE THE FALL: SOVIET CINEMA IN THE GORBACHEV YEARS, Anna Lawton")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("RED ATTACK, WHITE RESISTANCE: Civil War in South Russia 1918, by Peter Kenez.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("RED ADVANCE, WHITE DEFEAT: Civil War in South Russia 1919-1920, by Peter Kenez.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("ASPECTS OF BALKAN CULTURE, Jelena Milojkovic-Djuric")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("SLAVIC THINKERS OR THE CREATION OF POLITIES, Josette Baers")]), _vm._v(" "), _c('p', {
    staticClass: "noindt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SCARITH Books (fiction)")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("ON THE WAY TO RED SQUARE, by Julieta Almeida Rodrigues.")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("THE DA VINCI BARCODE, by Judith P. Shoaf")]), _vm._v(" "), _c('p', {
    staticClass: "noindt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("VELLUM Books (non fiction)")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("A RED SOX FAN’S DIARY OF THE 2004 SEASON, by Derek Catsam")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19129c49","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01a_Fm.vue
// module id = 60
// module chunks = 0